// extracted by mini-css-extract-plugin
export var content = "_ql-1";
export var divider = "_ql-0";